import { Card, Icon, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";

import { useTranslation } from "react-i18next";

import { doesCardHaveIcon, getPaymentIcon } from "@certn/utils";
import type { Schemas } from "../../types";

interface Props {
  profile: Schemas["PaginatedPaymentProfileListList"]["results"][number];
}

export function PaymentCard(props: Props) {
  const { profile } = props;
  const { t } = useTranslation();

  // TODO: Refactor to share card display logic with payment-details PaymentCard component
  // The icon + info section (lines 27-62) is nearly identical to the one in
  // /pages/general-settings/payment-profiles/components/PaymentCard.tsx
  // Consider extracting a shared PaymentCardDisplay component

  const formattedExpiryDate = profile.expiry_date
    ? `${profile.expiry_date.split("-")[1]}/${profile.expiry_date.split("-")[0]}`
    : "";

  return (
    <Card border="border-base" className={styles.card}>
      <div className={styles.content}>
        <div className={styles.icon}>
          {profile.brand && doesCardHaveIcon(profile.brand) ? (
            <img
              src={getPaymentIcon(profile.brand)}
              alt={profile.brand}
              width="24px"
              height="24px"
            />
          ) : (
            <Icon name="credit_card" size="space-6" />
          )}
        </div>
        <div className={styles.info}>
          {profile.number && (
            <Text style="global/body-primary">****{profile.number}</Text>
          )}
          {profile.brand && (
            <Text style="global/body-secondary">{profile.brand}</Text>
          )}
          {profile.expiry_date && (
            <div className={styles.bottomRow}>
              <Text style="global/body-secondary">
                {t("Expires")} {formattedExpiryDate}
              </Text>
              {profile.owner && (
                <span className={styles.spacer}>
                  <Text style="global/body-secondary">
                    {" \u00B7 "} {profile.owner}
                  </Text>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}

const styles = {
  card: css({
    padding: "var(--space-4)",
  }),
  content: css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
  }),
  icon: css({
    marginRight: "var(--space-3)",
  }),
  info: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "left",
  }),
  bottomRow: css({
    display: "flex",
    flexDirection: "row",
  }),
  spacer: css({
    paddingLeft: "var(--space-1)",
  }),
};
